import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';

import { Box, KeyboardArrowDownIcon, Typography } from '@occc-app/design-system';
import { Triggered_Message_Status } from '@occc/graphql';

import { colorByStatus, titleByStatus } from '../triggered-messages.constants';

type StatusBadgeProps = Omit<ComponentPropsWithoutRef<typeof Box>, 'children'> & {
  status: Triggered_Message_Status;
  isEditable?: boolean;
};

export const StatusBadge = forwardRef<ElementRef<typeof Box>, StatusBadgeProps>(
  ({ status, isEditable, sx, ...props }, ref) => {
    return (
      <Box
        {...props}
        ref={ref}
        sx={{
          ...sx,
          display: 'inline-flex',
          gap: 1,
          alignItems: 'center',
          bgcolor: 'common.white',
          color: 'text.primary',
          borderRadius: 24,
          px: 1,
          height: 26,
          cursor: isEditable ? 'pointer' : 'default',
          userSelect: 'none',
        }}
      >
        <Box width={12} height={12} borderRadius='50%' bgcolor={colorByStatus[status]} />
        <Typography component='span' variant='body2'>
          {titleByStatus[status]}
        </Typography>

        {isEditable ? <KeyboardArrowDownIcon fontSize='small' /> : null}
      </Box>
    );
  },
);

StatusBadge.displayName = 'StatusBadge';
